import { GsFormSchema } from '../../../components/gs-form/interfaces/gs-form-schema';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { ACTIVE_SCHEMA_FIELDS, PAGINATED_SCHEMA_FIELDS } from '../basics';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the webshop review component form.
 * Defines the fields to display for the form.
 */
export const ORDER_HISTORY_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...PAGINATED_SCHEMA_FIELDS,
    {
      formControlName: 'showSearchBar',
      label: 'components.orders.showSearchBar',
      description: 'components.orders.showSearchBarDescription',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'buttons',
      label: 'components.orders.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
